import React, {FC} from 'react';
import {Location} from 'components/TimePicker/types';
import {getDistance} from 'geolib';
import {useEvents} from 'hooks/useEvents';
import moment from 'moment-timezone';
import {sortkey} from 'utils/sort';

import Place from './Place';

import * as styles from './styles.module.scss';

type SimilarPlacesProps = {
	location: Location
}

const metersPerMile = 1609.34;
const maxEndDate = 30;
const maxPages = 3;
const maxPlaces = 4;

const SimilarPlaces: FC<SimilarPlacesProps> = ({location: selected}) => {
	const {state} = useEvents({
		region: selected.regions.primary,
		endDate: moment().add(maxEndDate, 'days').format('YYYY-MM-DD'),
		maxPages,
	});

	if (state.loading) {
		return null;
	}

	// Sort locations by distance
	const locations = state.locations
		.filter((l) => (
			l.datesLeft.length > 0 &&
			l.id !== selected.id
		))
		.map((l) => {
			return {
				location: l,
				distance: getDistance(
					selected.details.coords,
					l.details.coords,
				) / metersPerMile,
			};
		})
		.sort(sortkey((l) => l.distance))
		.slice(0, maxPlaces);

	if (locations.length === 0) {
		return null;
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.title}>Similar places nearby</div>
			<div className={styles.places}>
				{locations.map((l, i) => (
					<Place {...l} key={i} />
				))}
			</div>
		</div>
	);
};

export default SimilarPlaces;
